import React from 'react'
import { StyledFamilyImg, Title, StyledIntro, StyledIntroBold, StyledSection, VRButton, VRLogo } from './VirginRedSection.styles'
import { Col, Container, Row } from 'react-bootstrap'
import vrLogo from '../../img/vr-logo.svg'
import mobileIllustrationFamily from '../../img/illustration-family.svg'
import { ScrollAnimationContainer } from '../ScrollAnimationContainer'
import { PATHS } from '../../util/helpers/paths'

export const VirginRedSection = () => {
  return (
    <StyledSection>
      <Container>
        <Row>
          <Col lg={5}>
            <VRLogo src={vrLogo} className="d-lg-none" alt="Virgin Red Logo" />
            <Title as="h2">Champagne moments start here</Title>
          </Col>
          <Col lg={7} className="d-none d-lg-flex justify-content-end align-items-top">
            <VRLogo src={vrLogo} className="d-none d-lg-inline" alt="Virgin Red Logo" />
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <StyledIntroBold>This is Virgin Red — the club with epic rewards from Virgin and brands you love.</StyledIntroBold>
            <StyledIntro>
              Earn and spend Virgin Points on everyday moments (yes, even your commute), then turn them into flights, holidays, days out,
              treats and a few “how did I end up here?” stories.
            </StyledIntro>
            <ScrollAnimationContainer animationName="fadeInRight">
              <StyledFamilyImg className="d-lg-none" src={mobileIllustrationFamily} alt="" />
            </ScrollAnimationContainer>
            <VRButton href={PATHS.VIRGIN_RED} target="_blank" rel="noopener noreferrer">
              Join Virgin Red
            </VRButton>
          </Col>
          <Col>
            <ScrollAnimationContainer animationName="fadeInRight">
              <StyledFamilyImg className="d-none d-lg-block" src={mobileIllustrationFamily} alt="" />
            </ScrollAnimationContainer>
          </Col>
        </Row>
      </Container>
    </StyledSection>
  )
}
